import { z } from 'zod';

/** Speise / Weine focus when Menu Book opens from a food or drinks block. */
export const MenuBookFamilySchema = z.enum(['food', 'drinks', 'all']);
export type MenuBookFamily = z.infer<typeof MenuBookFamilySchema>;

const menuFamilyField = {
  family: MenuBookFamilySchema.optional(),
};

export const OperateSelectionSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('menu'), ...menuFamilyField }),
  z.object({
    mode: z.literal('menu-category'),
    categoryId: z.string().uuid(),
    columnIndex: z.number().int().nonnegative(),
    ...menuFamilyField,
  }),
  z.object({
    mode: z.literal('menu-item'),
    categoryId: z.string().uuid(),
    columnIndex: z.number().int().nonnegative(),
    itemIndex: z.number().int().nonnegative(),
    ...menuFamilyField,
  }),
  z.object({ mode: z.literal('forms'), formKey: z.string().min(1).optional() }),
  z.object({ mode: z.literal('floor') }),
  z.object({ mode: z.literal('floor-table'), tableId: z.string().uuid() }),
  z.object({ mode: z.literal('integrations') }),
  z.object({ mode: z.literal('inbox') }),
  z.object({ mode: z.literal('reservations') }),
]);

export type OperateSelection = z.infer<typeof OperateSelectionSchema>;
